import { ADMIN_MENU, BASE_URL } from "@/constants/constants";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";

const AdminTitle = () => {
  const { pathname } = useLocation();

  const title = useMemo(() => {
    const option = ADMIN_MENU.find(
      (menu) => menu.href !== BASE_URL && pathname.includes(menu.href),
    );
    if (!option) return "";
    return option.title;
  }, [pathname]);

  return (
    <div className="px-2 md:px-4 bg-[#EEEEEE] py-4]">
      <h1 data-testid="admin-title" className="text-xs">
        {title}
      </h1>
    </div>
  );
};

export default AdminTitle;
